module.exports = __webpack_public_path__ + "assets/img/ems.c71072e4.png";